import React, { PureComponent } from 'react'
import {connect} from "react-redux";
import * as actions from "../../store/actions/actions";
import Header from "../../components/Headers/Header";
import {Button, Card, CardBody, CardHeader, Container, FormGroup, Input, Row} from "reactstrap";
import Col from "react-bootstrap/Col";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";

import italianBankEditTranslations from "../../translations/bank/edit/it.bank.edit.json";
import englishBankEditTranslations from "../../translations/bank/edit/en.bank.edit.json";

class BankEdit extends PureComponent {
  state = {
    color: []
  };

  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianBankEditTranslations, "it");
    this.props.addTranslationForLanguage(englishBankEditTranslations, "en");
  }

  componentDidMount() {
    this.props.fetchCorporates()
  }

  onBackClick = () => {
    this.props.history.goBack();
  }

  submitHandler = async (event) => {
    event.preventDefault();
    this.props.updateBank(this.props.bankToUpdate)
  }

  render() {

    let errors="";
    errors=this.props.validationError;
    let bankContactError = ""
    let bankImageError = ""
    if(errors !== null && errors !== "" && errors !== undefined){
      if(errors.data.length>0){
        errors.data.map((item) =>{
          if(item.field === 'bankContact')
            bankContactError=item.defaultMessage;
          if(item.field === 'bankImage')
            bankImageError=item.defaultMessage;
          return ""
        });
      }
    }

    return (
        <>
          <Header />
          <Container className="mt--5" fluid>
            <Row>
              <div className="col" style={{paddingBottom:"2%"}}>
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row>
                      <div className="col">
                        <h3 className="mb-0">
                          <Translate id="bank.edit.title" data={{ bankName: this.props.bankName }}/>
                        </h3>
                      </div>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <form onSubmit={this.submitHandler}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="bankContact">
                                <Translate id="bank.edit.contact"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                    className={bankContactError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                    defaultValue="lucky.jesse"
                                    value={this.props.bankContact} onChange={this.onBankContactChange}
                                    id="bankContact"
                                    placeholder={translate("bank.edit.contact")}
                                    type="text"/>}
                              </Translate>
                              { bankContactError.length > 0 ? <label style={{color:"red"}}><Translate id={bankContactError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="files">
                                <Translate id="bank.edit.logo"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                    className={bankImageError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                    onChange={this.onBankImageChange}
                                    id="files"
                                    placeholder={translate("bank.edit.logo")}
                                    type="file"/>}
                              </Translate>
                              <span>
                                <small>
                                  <Translate id="bank.edit.logo.size" />
                                </small>
                              </span>
                              { bankImageError.length > 0 ? <label style={{color:"red"}}><Translate id={bankImageError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Row>
                              <Col>
                                <label className="form-control-label" htmlFor="files">
                                  <Translate id="bank.edit.primary.color"/>
                                </label>
                                <div>
                                  <label>
                                    <div className="result" style={{backgroundColor: this.state.color}}></div>
                                    <input type="color" id="color-picker" ref="color-value"
                                           onChange={this.onBankImagePrimaryColorChange.bind(this)}
                                           value={this.props.primaryColor}
                                    />
                                    <span className="select"></span>
                                  </label>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                        </Row>
                        <Row>
                          <Col align="left">
                            <Button onClick={this.onBackClick} variant="contained">
                              <i className="fas fa-arrow-left text-primary" />
                            </Button>
                          </Col>
                          <Col align="right">
                            <Button  type="submit" className="btn-success" variant="contained" >
                              <Translate id="bank.edit.update.button" data={{ bankName: this.props.bankName }}/>
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </form>
                  </CardBody>
                </Card>
              </div>
            </Row>
          </Container>
        </>
    );
  }

  onBankContactChange = (event) => {
    let bankContact = event.target.value
    this.props.bankContactChange(bankContact)
  }

  onEnabledChange = (event) => {
    let enabled = event.target.value === "true" ? true : false
    this.props.enabledChange(enabled)
  }

  onBankImageChange = async (event) => {
    let image = event.target.files[0]
    event.preventDefault();
    let toBase64 = file => new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
    this.props.bankImageChange(await toBase64(image))
  }

  onBankImagePrimaryColorChange=(value)=>{
    var tValue = value.target.value;
    this.props.bankPrimaryColorChangeRequest(tValue)
  }
  onBankImageSecondaryColorChange=(value)=>{
    var tValue = value.target.value;
    this.props.bankSecondaryColorChangeRequest(tValue)
  }
}

const mapStateToProps = state => {
  return {
    bankToUpdate: state.bankEdit.bankToEdit,
    idBank: state.bankEdit.bankToEdit.bankId,
    bankName: state.bankEdit.bankToEdit.bankName,
    bankContact: state.bankEdit.bankToEdit.bankContact,
    enabled: state.bankEdit.bankToEdit.enabled === true ? "true" : "false",
    corporate: state.bankEdit.bankToEdit.corporates,
    bankImage:state.bankEdit.bankToEdit.bankImage,
    primaryColor:state.bankEdit.bankToEdit.primaryColor,
    secondaryColor:state.bankEdit.bankToEdit.secondaryColor,
    validationError:state.bankEdit.error,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateBank: (bank) => dispatch({ type: actions.UPDATE_BANK_EDIT_REQUEST, value: bank }),
    bankContactChange: (bankContact) => dispatch({ type: actions.EDIT_BANK_BANK_CONTACT_FIELD_CHANGE_REQUEST, value: bankContact }),
    enabledChange: (enabled) => dispatch({ type: actions.EDIT_BANK_ENABLED_FIELD_CHANGE_REQUEST, value: enabled }),
    fetchCorporates: () => dispatch({ type: actions.FETCH_CORPORATES_REQUEST }),
    bankImageChange:(bankImage)=>dispatch({type:actions.EDIT_BANK_IMAGE_UPLOAD_REQUEST,value:bankImage}),
    bankPrimaryColorChangeRequest:(color)=>dispatch({type:actions.BANK_PRIMARY_COLOR_CHANGE_REQUEST,value:color}),
    bankSecondaryColorChangeRequest:(color)=>dispatch({type:actions.BANK_SECONDARY_COLOR_CHANGE_REQUEST,value:color})

  }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(BankEdit));